import { NgModule } from '@angular/core';

import { DialogComponent } from './components/dialog';
import { DialogTitleComponent } from './components/dialog-title';
import { DialogFooterComponent } from './components/dialog-footer';
import { DialogHeaderComponent } from './components/dialog-header';
import { DialogLoaderComponent } from './components/dialog-loader';
import { DialogContentComponent } from './components/dialog-content';

@NgModule({
  imports: [
    DialogComponent,
    DialogTitleComponent,
    DialogFooterComponent,
    DialogHeaderComponent,
    DialogLoaderComponent,
    DialogContentComponent,
  ],
  exports: [
    DialogComponent,
    DialogTitleComponent,
    DialogFooterComponent,
    DialogHeaderComponent,
    DialogLoaderComponent,
    DialogContentComponent,
  ],
})
export class DialogComponentsModule {}
